<template>
  <section class="flex flex-col gap-2">
    <section class="flex flex-col gap-2">
      <span class="font-bold flex flex-row items-center gap-2">
        <i class="fa-solid fa-clipboard"></i>
        {{ questionnaire ? questionnaire.title:'Anexos' }}
        <rpm-button
            v-if="questionnaire"
            color-class="transparent text-red-500 hover:text-red-600 focus:text-red-600"
            font-class="text-xl"
            icon="fa-solid fa-trash"
            tooltip-text="excluir todos os anexos"
            @click.stop="openDeleteAllQuestionnairesModal(sourceProcedure)"
        ></rpm-button>
      </span>

      <rpm-draggable v-if="questionnaire" :list="questionnaire.groups" v-slot="{ item: group }" class="flex flex-col gap-2">
        <rpm-accordion
            class="w-full rounded border border-gray-500/20"
            :absolute-open="openedAccordions[group.id]"
        >
          <template #header>
            <div class="w-full grid grid-cols-[auto_1fr] p-3 bg-black/5 dark:bg-white/5" :class="openedAccordions[group.id] ? 'border-b border-gray-500/20':''">
              <div class="flex flex-row items-center gap-3">
                <i class="fa-solid fa-grip-lines cursor-move"></i>
                <span class="text-md font-bold">
                  {{group.label}}
                </span>
              </div>
              <div class="flex flex-row-reverse items-center gap-2">
                <rpm-button
                    color-class="transparent text-red-500 hover:text-red-600 focus:text-red-600"
                    font-class="text-2xl"
                    icon="fa-solid fa-trash"
                    tooltip-text="excluir grupo"
                    @click.stop="openDeleteGroupModal(group)" ></rpm-button>
                <rpm-input
                    type="switch"
                    wrapper-class="h-[28px]"
                    :tooltip-text="group.enabled ? 'desabilitar grupo':'habilitar grupo'"
                    @click.stop="updateGroup(group, !group.enabled, 'enabled')"
                    v-model="group.enabled"
                ></rpm-input>
              </div>
            </div>
          </template>

          <template #default>
            <div class="w-full p-3">
              <group
                  :group="group"
                  :questionnaire="questionnaire"
              ></group>
            </div>
          </template>
        </rpm-accordion>
      </rpm-draggable>
    </section>

    <div class="flex flex-row items-center justify-center">
      <rpm-button
          icon="fa-solid fa-plus"
          class="px-4 py-2 rounded-md"
          tooltip-text="adicionar"
          font-class="text-md"
          @click="addGroup"
      ></rpm-button>
    </div>
  </section>

  <DeleteGroupModal
      :open="showDeleteGroupModal"
      :group="groupToDelete"
      @close="showDeleteGroupModal = false"
      @deleted="handleGroupDeleted"
  />

  <DeleteAllQuestionnairesModal
      :open="showDeleteAllQuestionnairesModal"
      :source-procedure="sourceProcedureToDeleteQuestionnaires"
      @close="showDeleteAllQuestionnairesModal = false"
      @deleted="handleAllQuestionnairesDeleted"
  />
</template>

<script>
import RpmDraggable from "#components/RpmDraggable.vue";
import RpmAccordion from "#components/RpmAccordion.vue";
import groupRepository from "#repositories/groupRepository";
import GroupStore from '#repositories/groupRepository';
import questionRepository from "#repositories/questionRepository";
import sourceProcedureRepository from "#repositories/sourceProcedureRepository";

import Group from "./group.vue";
import DeleteGroupModal from "../../modals/deleteModalQuestionnaire.vue";
import DeleteAllQuestionnairesModal from "../../modals/deleteAnexo.vue";

import _ from "lodash";

export default {
  name: "Questionnaire",
  components: {
    Group,
    RpmDraggable,
    RpmAccordion,
    DeleteGroupModal,
    DeleteAllQuestionnairesModal,
  },
  data() {
    return {
      openedAccordions: {},
      showDeleteGroupModal: false,
      groupToDelete: null,
      showDeleteAllQuestionnairesModal: false,
      sourceProcedureToDeleteQuestionnaires: null,
    };
  },
  props: {
    questionnaire: {
      type: Object
    },
    sourceProcedure: {
      type: Object
    }
  },
  methods: {
    openAccordion(id){
      this.openedAccordions[id] = !this.openedAccordions[id];
    },
    log: _.debounce(function () {
      this.$store.dispatch('reorderGroups', {'groups': _.map(this.groups, 'id')});
    }, 2000),
    getDefaultQuestionnaire() {
      return {
        title: 'Anexos',
        description: 'Descrição do questionário',
        enabled: true,
        source_procedure_id: this.sourceProcedure.id
      };
    },
    getDefaultGroup(id) {
      return {
        questionnaire_id: this.questionnaire ? this.questionnaire.id:id,
        label: 'Grupo de questões',
        description: 'Descrição do Grupo de questões',
        enabled: true
      };
    },
    async addGroup() {
      if(!this.questionnaire){
        this.$emit(
            'change-questionnaire',
            await this.pushGroup(
                (
                    await sourceProcedureRepository.storeQuestionnaire(this.sourceProcedure.id, this.getDefaultQuestionnaire())
                ).data
            )
        );
      } else this.pushGroup(this.questionnaire);
    },
    async pushGroup(questionnaire){
      questionnaire.groups.push(
          (
              await groupRepository.storeGroup(this.getDefaultGroup(questionnaire.id))
          ).data
      );

      return questionnaire;
    },

    async addQuestion(question) {
      let response = (await questionRepository.storeQuestion(question)).data

      this.groups.questions.push(response)
    },
    updateGroup(group, value, field){
      GroupStore.updateGroup(group.id, {
        [field]: value,
        questionnaire_id: this.questionnaire.id
      }).then((response) => {
        this.$notify(response.message, response.severity)
      })
    },

    openDeleteGroupModal(group) {
      this.groupToDelete = group;
      this.showDeleteGroupModal = true;
    },

    handleGroupDeleted() {
      if (this.questionnaire && this.groupToDelete) {
        this.questionnaire.groups = _.reject(this.questionnaire.groups, { id: this.groupToDelete.id });
      }
      this.groupToDelete = null;
      this.showDeleteGroupModal = false;
    },

    openDeleteAllQuestionnairesModal(sourceProcedure) {
      this.sourceProcedureToDeleteQuestionnaires = sourceProcedure;
      this.showDeleteAllQuestionnairesModal = true;
    },

    handleAllQuestionnairesDeleted() {
      this.$emit('all-questionnaires-deleted');
      this.showDeleteAllQuestionnairesModal = false;
      this.sourceProcedureToDeleteQuestionnaires = null;
    }
  },
};
</script>